/* content file: replace all html between <> </> with actual content */

export const Datenschutz = () => { 
  return (
  <>
    <p>
      Diese Datenschutzerklärung gilt für die Webseite „ga-lotse.de“ (bzw. „https://ga-lotse.de“ sowie dazu zugehörige Subdomains) des Gesundheitsamts der Stadt Frankfurt am Main. Dieses Informationsportal bietet Informationen zu besonderen Ereignissen und wird ausschließlich zu dem Zwecke genutzt.
    </p>
    <br/>

    <h3 className="text-xl mb-2">1. Name und Kontaktdaten des für die Verarbeitung Verantwortlichen sowie des behördlichen Datenschutzbeauftragten</h3>
    <br/>
    <p>
      Diese Datenschutz-Information gilt für die Datenverarbeitung durch:<br/>
      <strong>Verantwortlicher:</strong><br/>
      Verantwortlich für die Website „ga-lotse.de“ ist das Gesundheitsamt Frankfurt am Main:<br/>
      Gesundheitsamt Frankfurt am Main<br/>
      Breite Gasse 28<br/>
      60313 Frankfurt am Main<br/>
      E-Mail: 
      <a 
        href="mailto:datenschutz.gesundheitsamt@stadt-frankfurt.de"
        className="text-primary-plain-Color hover:underline"
        >
        datenschutz.gesundheitsamt@stadt-frankfurt.de
      </a>
    </p>
    <br/>
    <p>
      <strong>Behördlicher Datenschutzbeauftragter:</strong><br/>
      Referat Datenschutz und IT-Sicherheit<br/>
      Sandgasse 6<br/>
      60311 Frankfurt am Main
    </p>

    <br/>

    <h3 className="text-xl mb-2">
      2. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung
    </h3>
    <h4 className="text-lg mb-2">
      2.1 Beim Besuch der Website
    </h4>
    <p>
      Beim Aufrufen unserer Website „ga-lotse.de“ werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sog. Logfile gespeichert. Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:
    </p>
    <ul>
      <li>IP-Adresse des anfragenden Rechners</li>
      <li>Datum und Uhrzeit des Zugriffs</li>
      <li>Name und URL der abgerufenen Datei</li>
      <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
      <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers</li>
    </ul>
    <p>
      Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:
    </p>
    <ul>
      <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
      <li>Gewährleistung einer komfortablen Nutzung unserer Website</li>
      <li>Auswertung der Systemsicherheit und -stabilität</li>
      <li>Rückverfolgung etwaiger DoS Attacken</li>
      <li>Zu weiteren administrativen Zwecken</li>
    </ul>

    <br/>

    <h3 className="text-xl mb-2">
      3. Weitergabe von Daten
    </h3>
    <p>Es findet keine Weitergabe von Daten an Dritte statt.</p>
    <br/>
    <h3 className="text-xl mb-2">
      4. Cookies
    </h3>
    <p>
      Wir setzen auf unserer Seite keine Cookies ein.
    </p>
    <br/>
    <h3 className="text-xl mb-2">
      5. Analyse-Tools
    </h3>
    <p>Es werden keine Analyse-Tools verwendet.</p>
    <br/>
    <h3 className="text-xl mb-2">
      6. Social Media Plug-ins
    </h3>
    <p>
      Es werden keine Social Media Plug-ins verwendet.
    </p>
    <br/>
    <h3 className="text-xl mb-2">
      7. Betroffenenrechte
    </h3>
    <p>
      Sie haben das Recht:
    </p>
    <ul>
      <li>gemäß Art. 15 DS-GVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen...</li>
      <li>gemäß Art. 16 DS-GVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen...</li>
      <li>gemäß Art. 17 DS-GVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen...</li>
      <li>gemäß Art. 18 DS-GVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen...</li>
      <li>gemäß Art. 20 DS-GVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten...</li>
      <li>gemäß Art. 7 Abs. 3 DS-GVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen...</li>
      <li>gemäß Art. 77 DS-GVO sich bei der zuständigen Aufsichtsbehörde zu beschweren...</li>
    </ul>
  <br/>
    <h3 className="text-xl mb-2">
      8. Widerspruchsrecht
    </h3>
    <p>
      Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DS-GVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DS-GVO Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten einzulegen...
    </p>
  <br/>
    <h3 className="text-xl mb-2">
      9. Datensicherheit
    </h3>
    <p>
      Wir bedienen uns geeigneter technischer und organisatorischer Sicherheitsmaßnahmen...
    </p>
  <br/>
    <h3 className="text-xl mb-2">
      10. Auftragsverarbeitung
    </h3>
    <p>
      Es findet keine Auftragsverarbeitung der erhobenen Daten statt.
    </p>
  <br/>
    <h3 className="text-xl mb-2">
      11. Aktualität und Änderung dieser Datenschutzerklärung
    </h3>
    <p>
      Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Oktober 2024.
    </p>
  </>   
  )
}